(function( $ ) {
    'use strict';

    $( window ).load(function() {

        //
        //
        // ===========================================================================

        if ($('#js-edc-home-list-sort').length) {

            var options = {
                listClass: 'js-edc-list',
                sortClass: 'js-edc-sort',
                valueNames: [
                    'js-edc-sort-num',
                    'js-edc-sort-address',
                    'js-edc-sort-type',
                    'js-edc-sort-size',
                    'js-edc-sort-rooms',
                    'js-edc-sort-balcony-size',
                    'js-edc-sort-price',
                    'js-edc-sort-downpayment',
                    'js-edc-sort-monthly-rent',
                    'js-edc-sort-deposit',
                    'js-edc-sort-aconto',
                    'js-edc-sort-status',
                    'js-edc-sort-date-available'
                ]
            };

            var edc_home_list = new List('js-edc-home-list-sort', options);

        };

    });

})( jQuery );
